
const hostToClient: Record<string, string> = {
    "gtlaw2": "GT",
    "dev": "default",
  };
  
  export function resolveClientFromHost(host: string): string {
    for (const key in hostToClient) {
      if (host.includes(key)) {
        return hostToClient[key];
      }
    }
    return "default";
  }
  